var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isPreview())?_c('div',{staticClass:"chapter-view",on:{"click":function($event){return _vm.hideChapterView()}}},[_c('h1',{staticClass:"chapter-view__text",domProps:{"innerHTML":_vm._s(_vm.htmlText)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }